import { Validators, UntypedFormBuilder, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { BaseFilterComponent } from '../base-filter.component';
import { MatSelectChange } from '@angular/material/select';
import { GuidFilterType } from 'src/app/core/services/api-services';
import { FilterType } from 'src/app/core/common/filter-type';
import EnumHelper from 'src/app/core/helpers/enum.helper';
import { Filter, IdNameModel } from 'src/app/core/models/filter-paging.model';

@Component({
    selector: 'app-guid-filter',
    templateUrl: './guid-filter.component.html',
    styleUrls: ['./guid-filter.component.scss'],
    standalone: false
})
export class GuidFilterComponent extends BaseFilterComponent<GuidFilterType> implements OnInit {

  @Input() options: IdNameModel[] = [];
  @Input() filterSelectText: string | undefined;

  // StringFilterType
  guidFilterType = GuidFilterType;

  guidContainsFilter = GuidFilterType.Contains;

  filterForm = new FormGroup({
    filterType: new FormControl<GuidFilterType>(GuidFilterType.Equals, { validators: [Validators.required], nonNullable: true }),
  });

  guidForm = new FormGroup({
    value: new FormControl<string>('', { validators: [Validators.required] }),
  });

  multipleGuidForm = new FormGroup({
    value: new FormControl<string>('', { validators: [Validators.required] }),
  });

  filterOptions = this.getFilterOptions();
  currentFilter = new BehaviorSubject<GuidFilterType>(GuidFilterType.Equals);
  filterType: FilterType = FilterType.Guid;

  constructor() {
    super();
   }

  getFilterOptions(): { value: number, translationKey: string }[] {
    const options: { value: number, translationKey: string }[] = [];

    Object.keys(GuidFilterType).filter((enumVal) => !isNaN(Number(enumVal))).forEach((enumVal: any) => {
      options.push({
        value: parseInt(enumVal, 10),
        translationKey: `Common.Filters.GuidFilters.${GuidFilterType[enumVal]}`
      });
    });

    return options;
  }

  onFilterChange($event: MatSelectChange): void {
    this.currentFilter.next($event.value as GuidFilterType);
  }

  ngOnInit(): void {
    if (this.initialValue) {
      this.currentValue.next(this.initialValue);
    }
  }

  clearFilter(): void {
    this.currentValue.next(null);
    this.activeFilterField = this.currentValue.value !== null;
    this.guidForm.reset();
    this.multipleGuidForm.reset();
  }

  initValue(value: Filter<GuidFilterType>): void {
    this.guidForm.markAllAsTouched();
    this.currentFilter.next(value.filterType);

    if (value.filterType === 0) {
      this.guidControl.setValue(value.values[0]);
    } else if (value.filterType === 1) {
      this.multipleGuidControl.setValue(value.values);
    }

    this.filterTypeControl.setValue(value.filterType);
    this.currentValue.next(value);
    this.activeFilterField = this.currentValue.value !== null;
  }

  onSubmit($event: any): void {
    if (this.currentFilter.value !== GuidFilterType.Contains) {
      // Trigger form validation for untouched fields
      this.guidForm.markAllAsTouched();

      if (this.guidForm.valid) {
        const model: Filter<GuidFilterType> = {
          filterType: this.currentFilter.value,
          values: [this.guidControl.value, null] as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
        this.filterChanged.emit({ filter: this.currentValue.value, filterType: this.filterType, propertyName: this.propertyName });
        this.activeFilterField = this.currentValue.value !== null;
      } else {
        $event.stopPropagation();
      }
    } else {
      // Trigger form validation for untouched fields
      this.multipleGuidForm.markAllAsTouched();

      if (this.multipleGuidForm.valid) {
        const model: Filter<GuidFilterType> = {
          filterType: this.currentFilter.value,
          values: this.multipleGuidControl.value as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
        this.filterChanged.emit({ filter: this.currentValue.value, filterType: this.filterType, propertyName: this.propertyName });
        this.activeFilterField = this.currentValue.value !== null;
      } else {
        $event.stopPropagation();
      }
    }
  }

  onCancel(): void {
  }

  get guidControl(): FormControl {
    return this.guidForm.get('value')! as FormControl;
  }

  get multipleGuidControl(): FormControl {
    return this.multipleGuidForm.get('value')! as FormControl;
  }

  get filterTypeControl(): FormControl {
    return this.filterForm.get('filterType')! as FormControl;
  }

}
